export const TextStyle = {
  baseStyle: {
    fonts: 'Work Sans',
    fontWeight: 400,
    color: 'BLACK',
  },
  variants: {
    link: {
      fontSize: 16,
      color: 'NAVY',
      lineHeight: 1.2,
      textTransform: 'none',
    },
    contentHeaderResume: {
      fontSize: 14,
      paddingLeft: [0, 0, '64px'],
      textTransform: 'uppercase',
    },
    contentHeaderSection: {
      color: 'ORANGE_TEXT',
      fontSize: 14,
      fontWeight: 600,
      textTransform: 'uppercase',
    },
    linkIcon: {
      color: 'NAVY',
      fontSize: 14,
      fontWeight: 500,
    },
    sectionText: {
      fontSize: [16],
      fontWeight: 500,
      color: 'BLACK',
      // lineHeight: 1.2,
    },
    companyName: {
      fontSize: '16px',
      fontWeight: 400,
      textTransform: 'uppercase',
    },
    errorMessage: {
      color: 'RED',
      fontSize: '14px',
      fontWeight: 600,
      textTransform: 'uppercase',
    },
    instructions: {
      fontSize: 16,
      color: 'BLACK',
      fontWeight: 400,
      lineHeight: 1.1,
      paddingBottom: 1,
    },
    t24: {
      fontSize: 24,
    },
    t18: {
      fontSize: 18,
    },
    t16: {
      fontSize: 16,
    },
    t14: {
      fontSize: 14,
    },
    t12: {
      fontSize: 12,
    },
    o16: {
      fontSize: 16,
      fontWeight: 600,
      color: 'ORANGE_TEXT',
    },
    o14: {
      fontSize: 14,
      fontWeight: 600,
      color: 'ORANGE_TEXT',
    },
    o10: {
      fontSize: 10,
      fontWeight: 600,
      color: 'ORANGE_TEXT',
    },
  },
};
